const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

function assertNonEmptyString(value, fieldName) {
  if (typeof value !== 'string' || !value) {
    throw new Error(`${fieldName} must be a non-empty string.`);
  }
}

export function toUint8Array(value, fieldName = 'value') {
  if (value instanceof Uint8Array) {
    return value;
  }
  if (value instanceof ArrayBuffer) {
    return new Uint8Array(value);
  }
  if (ArrayBuffer.isView(value)) {
    return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
  }
  throw new Error(`${fieldName} must be binary data.`);
}

export function utf8ToBytes(value) {
  if (typeof value !== 'string') {
    throw new Error('value must be a string.');
  }
  return textEncoder.encode(value);
}

export function bytesToUtf8(value) {
  const bytes = toUint8Array(value, 'value');
  return textDecoder.decode(bytes);
}

export function bytesToBase64(value) {
  const bytes = toUint8Array(value, 'value');

  if (typeof Buffer !== 'undefined') {
    return Buffer.from(bytes).toString('base64');
  }

  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export function base64ToBytes(value, fieldName = 'base64') {
  if (value === '') {
    return new Uint8Array();
  }
  assertNonEmptyString(value, fieldName);

  if (typeof Buffer !== 'undefined') {
    return new Uint8Array(Buffer.from(value, 'base64'));
  }

  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function concatBytes(...parts) {
  const normalized = parts.map((part, idx) => toUint8Array(part, `parts[${idx}]`));
  const totalLength = normalized.reduce((sum, part) => sum + part.length, 0);
  const result = new Uint8Array(totalLength);
  let offset = 0;

  for (const part of normalized) {
    result.set(part, offset);
    offset += part.length;
  }

  return result;
}

export function randomBytes(length) {
  if (!Number.isInteger(length) || length <= 0) {
    throw new Error('length must be a positive integer.');
  }
  if (!globalThis.crypto?.getRandomValues) {
    throw new Error('Secure random source is unavailable.');
  }
  const bytes = new Uint8Array(length);
  globalThis.crypto.getRandomValues(bytes);
  return bytes;
}
